import React from 'react'
import { Grid, Card, CardHeader, CardContent } from '@material-ui/core'

import SupplierProfileForm from '../update/supplierProfileForm'

const SupplierCreate = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <Card>
          <CardHeader title='Supplier Profile' />
          <CardContent className='card-content'>
            <SupplierProfileForm />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default SupplierCreate
